























import Vue from 'vue';
import moment from 'moment';
import 'moment/locale/nb'; // Norwegian Bokmål locale
import { createNamespacedHelpers, mapState } from 'vuex';
import Clip from '@/assets/img/clip.svg';
import { mapState as mapRootState } from 'vuex';
const mapCustomLabelsState = createNamespacedHelpers('customLabels').mapState;
export default Vue.extend({
    components: {
        Clip,
    },
    props: {
        followUp: {
            type: Object,
            required: true,
        },
        active: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapCustomLabelsState(['originalGrievance']),
        ...mapState(['locale']),
        ...mapRootState(['portalBranding']),
        descriptionShort() {
            if (this.followUp.description.length > 200) {
                return this.followUp.description.slice(0, 200) + '...';
            }
            return this.followUp.description;
        },
        hasDocuments() {
            return !!this.followUp.documents?.length;
        },
        dateString() {
            // Map 'no' to 'nb' for moment.js (Norwegian Bokmål)
            const momentLocale = this.locale === 'no' ? 'nb' : this.locale;
            moment.locale(momentLocale);
            return moment(this.followUp.date).format('LL');
        },
        dateTimeString() {
            // Map 'no' to 'nb' for moment.js (Norwegian Bokmål)
            const momentLocale = this.locale === 'no' ? 'nb' : this.locale;
            moment.locale(momentLocale);
            return moment(this.followUp.date).format('LLL');
        },
    },
});
